import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Modal,
  ListGroup,
  InputGroup,
  FormControl,
} from "react-bootstrap";
import { modifyRolesUsuario } from "../../reducers/usuario_slice";
import { fetchRoles } from "../../reducers/rol_slice";
// >>> agregado: thunk del slice de afiliado
import { fetchAfiliadoByIdPersona } from "../../reducers/afiliado_slice";

const FormRolesUsuario = ({ show, handleClose, usuario }) => {
  const dispatch = useDispatch();
  const roles = useSelector((state) => state.rol.roles);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const currentUsuarioId = useSelector(state => state.sesion.id)
  const [availableRoles, setAvailableRoles] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // --- agregado: para mostrar el mensaje de validación ---
  const [errorMsg, setErrorMsg] = useState("");

  // --- agregado: afiliado actual desde el slice (fetchAfiliadoByIdPersona guarda en 'current')
  const afiliado = useSelector((state) => state.afiliado.current);

  // --- agregado: helpers para situación ---
  const SITUACION_TRASLADO_LOCAL_ID = 3; // alias: trasladoc, nombre: TRASLADO LOCAL

  const getSituacionNombre = (u) => {
    const s = u?.situacion;
    if (typeof s === "string") return s;
    if (s && typeof s === "object") return (s.nombre ?? "").toString();
    return "";
  };

  const getSituacionAlias = (u) => {
    const s = u?.situacion;
    if (s && typeof s === "object") return (s.alias ?? "").toString();
    return "";
  };

  const getSituacionId = (u) => {
    // puede venir como campo plano o dentro de 'situacion'
    if (Number.isFinite(u?.id_situacion)) return u.id_situacion;
    if (u?.situacion && Number.isFinite(u.situacion.id)) return u.situacion.id;
    return undefined;
  };

  // >>> ajustado: primero valida con afiliado.id_situacion === 3; si no hay afiliado, cae al esquema previo
  const cumpleTrasladoLocal = (u) => {
    if (Number(afiliado?.id_situacion) === SITUACION_TRASLADO_LOCAL_ID) return true;
    const id = getSituacionId(u);
    const nombre = getSituacionNombre(u).toUpperCase();
    const alias = getSituacionAlias(u).toUpperCase();
    return (
      id === SITUACION_TRASLADO_LOCAL_ID ||
      nombre === "TRASLADO LOCAL" ||
      alias === "TRASLADOC"
    );
  };

  //  console.log("selectedRoles", selectedRoles);
  useEffect(() => {
    if (usuario) {
      setSelectedRoles([...usuario.roles]);
    }
    dispatch(fetchRoles());
  }, [dispatch, usuario]);

  useEffect(() => {
    if (usuario.roles) {
      const available = roles.filter(
        (rol) =>{
          return !usuario.roles.some(
            (rolU) =>
             {
              console.log("Rol y rolu", rol.id, rolU.id)
              return rolU.id === rol.id}
          ) }
      );
      setAvailableRoles(available);
    }
  }, [roles, usuario]);

  // >>> agregado: cargar afiliado por id_persona del usuario
  useEffect(() => {
    const idPersona = usuario?.id_persona ?? usuario?.persona?.id;
    if (idPersona) {
      dispatch(fetchAfiliadoByIdPersona(idPersona));
    }
  }, [dispatch, usuario?.id_persona, usuario?.persona?.id]);

  const handleAddRoles = (rolToAdd) => {
    // --- validación específica para LOCALES (alias COLOC) ---
    const aliasUpper = (rolToAdd?.alias ?? "").toString().toUpperCase();
    const nombreUpper = (rolToAdd?.nombre ?? "").toString().toUpperCase();
    const isLocales = aliasUpper === "COLOC" || nombreUpper === "LOCALES";
    if (isLocales) {
      if (!cumpleTrasladoLocal(usuario)) {
        setErrorMsg("No se puede asignar el rol LOCALES (COLOC). El afiliado del usuario debe tener la situación TRASLADO LOCAL.");
        return; // bloquear la asignación
      }
    }
    // si pasa, limpiar cualquier mensaje previo
    setErrorMsg("");

    setSelectedRoles((prevSelected) => [
      ...prevSelected, rolToAdd,
    ]);
    setAvailableRoles((prevAvailableRoles) =>
      prevAvailableRoles.filter((rol) => rol.id !== rolToAdd.id)
    );
  };

  const handleRemoveRoles = (rolToRemove) => {
    setAvailableRoles((prevAvailableRoles) => [
      ...prevAvailableRoles,
      rolToRemove,
    ]);
    setSelectedRoles((prevSelected) =>{
      return prevSelected.filter((rol) => rol.id !== rolToRemove.id)}
    );
    // opcional: limpiar mensaje al quitar
    setErrorMsg("");
  };

  const handleSave = async () => {
    const rolesToSend = selectedRoles.map((rol) => ({
      idrol: rol.id,
      idusu: usuario.id,
    }));
    const fd = new FormData();
    fd.append("roles", JSON.stringify(rolesToSend));

    dispatch(modifyRolesUsuario({id:usuario.id, roles: fd})).then((res) => {
      handleClose();
    });
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredRoles = availableRoles.filter((rol) =>
    rol.nombre.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (!usuario || !usuario.id) {
    return null;
  }
  const sortedRoles = [...selectedRoles].sort(
    (a, b) => {
      if (a.id < b.id) {
        return -1;
      }
      if (a.id > b.id) {
        return 1;
      }
      return 0;
    }
  );

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton style={{ backgroundColor: "#255957", color: 'white' }}>
          <Modal.Title>
            Gestión de Roles del usuario: {usuario.usuario}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* --- mensaje de validación --- */}
          {errorMsg && (
            <div className="alert alert-warning mb-3" role="alert">
              {errorMsg}
            </div>
          )}

          <div className="container">
            <div className="row">
              <div className="col-lg-6 mt-3">
                <div className="w-100">
                  <h5>Roles Disponibles</h5>
                  <InputGroup className="mb-3">
                    <FormControl
                      placeholder="Buscar por nombre"
                      aria-label="Buscar por nombre"
                      aria-describedby="basic-addon2"
                      value={searchTerm}
                      onChange={handleSearchChange}
                    />
                  </InputGroup>
                  <ListGroup style={{ maxHeight: "400px", overflowY: "auto" }}>
                    {filteredRoles.map((rol) => (
                      <ListGroup.Item key={rol.id}>
                        <div className="d-flex justify-content-between">
                          {rol.nombre}
                          <button className="icon-button btn-secondary-outline" title="Asignar rol" onClick={() => handleAddRoles(rol)}>
                              <i className="bi bi-plus-lg"></i>
                          </button>
                        </div>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </div>
              </div>
              <div className="col-lg-6 mt-3">
                <div className="w-100">
                  <h5>Roles asignados al usuario</h5>
                  <ListGroup style={{ maxHeight: "400px", overflowY: "auto" }}>
                    {sortedRoles.map((rol) => (
                      <ListGroup.Item key={rol.id}>
                        <div className="d-flex justify-content-between">
                          {rol.nombre}
                         
                            {(currentUsuarioId === usuario.id? rol.alias !== "admin" : true)&&
                           <button className="icon-button btn-secondary-outline" title="Quitar rol" onClick={() => handleRemoveRoles(rol)}>
                              <i className="bi bi-dash-lg"></i>
                          </button>
}
                        </div>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="button-mine btn-cancel-outline" onClick={handleClose} type='button'>
              Cancelar
          </button>
          <button className="button-mine btn-success-outline" type="button" onClick={handleSave}>
            <i className="bi bi-check-circle"></i> Guardar
            </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FormRolesUsuario;
